// extracted by mini-css-extract-plugin
export var centerText = "_c7-8";
export var container = "_c7-0";
export var doughnutContainer = "_c7-7";
export var legend = "_c7-a";
export var legendItemColorDisplay = "_c7-b";
export var legendItemLabel = "_c7-d";
export var legendItemValue = "_c7-c";
export var lg = "_c7-5";
export var maxWidth = "_c7-9";
export var md = "_c7-4";
export var responsive = "_c7-6";
export var sm = "_c7-3";
export var xs = "_c7-2";
export var xxs = "_c7-1";